import { apiClient } from './api/apiClient';
import type { Farm } from '../types/farm';
import type { Field } from '../types/field';
import type { FarmApiDTO, FieldApiDTO, PageApiDTO } from '../types/api';
import { mapFarmDtoToFarm, mapFieldDtoToField } from '../types/api';

/**
 * 農場サービス
 * バックエンドAPIから農場・圃場データを取得する
 */
class FarmService {
  /**
   * 農場詳細を取得する
   * @param farmId - 農場 ID
   * @returns 農場情報
   */
  async getFarm(farmId: number): Promise<Farm> {
    const dto = await apiClient.get<FarmApiDTO>(`/farms/${farmId}`);
    return mapFarmDtoToFarm(dto);
  }

  /**
   * 農場配下の圃場一覧を取得する
   * TODO: ページネーション未対応。300件超の圃場がある農場では後続ページが取得されない。
   * @param farmId - 農場 ID
   * @returns 圃場一覧
   */
  async getFieldsByFarm(farmId: number): Promise<Field[]> {
    const response = await apiClient.get<PageApiDTO<FieldApiDTO>>(`/farms/${farmId}/fields`, {
      size: '300',
    });
    return response.content.map(mapFieldDtoToField);
  }

  /**
   * 地区配下の農場一覧を取得する
   * TODO: ページネーション未対応。300件超の農場がある地区では後続ページが取得されない。
   * @param areaId - 地区 ID
   * @returns 農場一覧
   */
  async getFarmsByArea(areaId: number): Promise<Farm[]> {
    const response = await apiClient.get<PageApiDTO<FarmApiDTO>>(`/areas/${areaId}/farms`, {
      size: '300',
    });
    return response.content.map(mapFarmDtoToFarm);
  }
}

/** 農場サービスのシングルトンインスタンス */
export const farmService = new FarmService();
